<template>
    <el-card class="box-card">
        <!-- 表单只有一个文本框的时候，按回车会自动submit表单，需要禁用sunmit -->
        <el-form
            ref="searchform"
            :inline="true"
            :model="form"
            @submit.native.prevent
            size="medium"
        >
            <el-form-item  label="状态" prop="state">
                <el-select
                    v-model="form.state"
                    filterable
                    clearable
                    placeholder=""
                    class="state_c"
                >
                    <el-option
                        v-for="item in AllState"
                        :key="item.name"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="名称" prop="name">
                <el-input
                    v-model="form.name"
                    placeholder="聊天框名称"
                    @keyup.enter.native="search()"
                    clearable
                    class="name_c"
                ></el-input>
            </el-form-item>
            <el-form-item  label="类型" prop="type">
                <el-select
                    v-model="form.type"
                    filterable
                    clearable
                    placeholder=""
                    class="type_c"
                >
                    <el-option
                        v-for="item in AllType"
                        :key="item.name"
                        :label="item.name"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="search">搜索</el-button>
                <el-button type="warning" plain @click="resetbtn('searchform')"
                    >重置</el-button
                >
            </el-form-item>
            <el-button
                v-if="$_has(AddAuth)"
                type="success"
                plain
                round
                @click="addTeam"
                class="temp_add"
                size="medium"
                >添加聊天框</el-button
            >
        </el-form>
    </el-card>
</template>

<script>
export default {
    name: 'ShopChatSearchBarComponent',
    data() {
        return {
            fdialogFormVisible: false,
            form: {
                state: 1,
                name: '',
                type: '',
                page: 1
            }
        }
    },
    computed: {},
    methods: {
        search() {
            this.$emit('search', this.form)
        },
        resetbtn(f) {
            this.$refs[f].resetFields()
        },
        addTeam() {
            this.$emit('addTeam')
        },
    },
    filters: {},
    props: {
        AllState: {
            type: Array,
            default() {
                return []
            },
        },
        AllType: {
            type: Array,
            default() {
                return []
            },
        },
        AddAuth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {},
}
</script>

<style lang='less' scoped>
.box-card .el-form-item {
    margin-bottom: 5px;
}
.temp_add {
    float: right;
    margin-bottom: 10px;
}
.name_c {
    width:200px
}
.state_c {
    width:200px
}
.type_c {
    width:200px
}
</style>